export default [
  {
    path: '/status-study',
    name: 'statusStudyApp',
    component: () => import(/* webpackChunkName: "statusApp" */'@/views/study-status/study/status-study-app'),
    children: [
      {
        path: '',
        name: 'statusStudyAttend',
        component: () => import(/* webpackChunkName: "statusStudyAttend" */'@/views/study-status/study/comp/status-study-attend'),
      },
      {
        path: 'schedule',
        name: 'statusStudySchedule',
        component: () => import(/* webpackChunkName: "statusStudySchedule" */'@/views/study-status/study/comp/status-study-schedule'),
      },
      {
        path: 'report',
        name: 'statusStudyReport',
        component: () => import(/* webpackChunkName: "statusStudyReport" */'@/views/study-status/study/comp/status-study-report-app.vue'),
        children: [
          {
            path: '',
            name: 'statusStudyWeeklyReport',
            component: () => import(/* webpackChunkName: "statusStudyWeeklyReport" */'@/views/study-status/study/comp/status-study-weekly-report.vue'),
          },
          {
            path: 'monthly',
            name: 'statusStudyMonthlyReport',
            component: () => import(/* webpackChunkName: "statusStudyMonthlyReport" */'@/views/study-status/study/comp/status-study-monthly-report.vue'),
          },
        ],
      },
    ]
  },
  {
    path: '/study-weekly',
    name: 'studyWeeklyReport',
    component: () => import(/* webpackChunkName: "studyWeeklyReport" */'@/views/study-status/study/study-weekly-report.vue'),
  },
  {
    path: '/study-monthly',
    name: 'studyMonthlyReport',
    component: () => import(/* webpackChunkName: "studyMonthlyReport" */'@/views/study-status/study/study-monthly-report.vue'),
  },
  {
    path: '/schedule/detail/:date',
    name: 'statusStudyScheduleDetail',
    component: () => import(/* webpackChunkName: "statusStudyScheduleDetail" */'@/views/study-status/study/comp/status-study-schedule-detail'),
    props: true,
  },
  {
    path: '/schedule/detail/modi/:date',
    name: 'statusStudyScheduleModi',
    component: () => import(/* webpackChunkName: "statusStudyScheduleModi" */'@/views/study-status/study/comp/status-study-schedule-modi'),
    props: true,
  },
  // 리딩 관련 라우터
  {
    path: '/status-reading',
    name: 'statusReadingApp',
    component: () => import(/* webpackChunkName: "statusReadingApp" */'@/views/study-status/reading/status-reading-app'),
    children: [
      {
        path: '',
        name: 'statusReadingAttend',
        component: () => import(/* webpackChunkName: "statusReadingAttend" */'@/views/study-status/reading/comp/status-reading-attend'),
      },
      {
        path: 'schedule',
        name: 'statusReadingSchedule',
        component: () => import(/* webpackChunkName: "statusReadingSchedule" */'@/views/study-status/reading/comp/status-reading-schedule'),
      },
      {
        path: 'superbook',
        name: 'statusMysuperbook',
        component: () => import(/* webpackChunkName: "statusMysuperbook" */'@/views/study-status/reading/comp/status-mysuperbook'),
        children: [
          {
            path: '',
            name: 'weeklyReport',
            component: () => import(/* webpackChunkName: "weeklyReport" */'@/views/study-status/reading/comp/weekly-report'),
          },
          {
            path: 'monthly',
            name: 'monthlyReport',
            component: () => import(/* webpackChunkName: "monthlyReport" */'@/views/study-status/reading/comp/monthly-report'),
          }
        ]
      }
    ]
  },
  {
    path: '/reading/detail/:date',
    name: 'statusReadingScheduleDetail',
    component: () => import(/* webpackChunkName: "statusReadingScheduleDetail" */'@/views/study-status/reading/comp/status-reading-schedule-detail'),
    props: true,
  },
  {
    path: '/reading/detail/modi/:date',
    name: 'statusReadingScheduleModi',
    component: () => import(/* webpackChunkName: "statusReadingScheduleModi" */'@/views/study-status/reading/comp/status-reading-schedule-modi'),
    props: true,
  },
]
